import React from 'react';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import { IdentificationProvider } from './IdentificationContext';
import Demo from './Demo.js';
import IDVerification from './IDVerification.js';
import SelectIDType from './SelectIDType.js';
import CaptureInstructions from './CaptureInstructions.js';
import CaptureDocument from './CaptureDocument.js';
import ConsentScreen from './ConsentScreen.js';
import FaceScanPrep from './FaceScanPrep.js';
import FaceCapture from './FaceCapture.js';
import AgeVerified from './AgeVerified.js';
import AgeEstimationConsent from './AgeEstimationConsent.js';
import AgeEstimationScan from './AgeEstimationScan.js';
import AgeEstimationHowItWorks from './AgeEstimationHowItWorks.js';
import DigitalIdApp from './DigitalIdApp.js';
import DigitalIdCallback from './DigitalIdCallback.js';
import PrivacyPolicy from './PrivacyPolicy.js';
import TermsAndConditions from './TermsAndConditions.js';

function App() {
  return (
    <IdentificationProvider>
      <div className="App">
        <Routes>
          <Route path="/" element={<Demo />} />
          <Route path="/id-verification" element={<IDVerification />} />
          <Route path="/select-id-type" element={<SelectIDType />} />
          <Route path="/capture-instructions" element={<CaptureInstructions />} />
          <Route path="/capture-document" element={<CaptureDocument />} />
          <Route path="/consent" element={<ConsentScreen />} />
          <Route path="/face-scan-prep" element={<FaceScanPrep />} />
          <Route path="/face-capture" element={<FaceCapture />} />
          <Route path="/age-verified" element={<AgeVerified />} />
          <Route path="/age-estimation/how-it-works" element={<AgeEstimationHowItWorks />} />
          <Route path="/age-estimation/consent" element={<AgeEstimationConsent />} />
          <Route path="/age-estimation/scan" element={<AgeEstimationScan />} />
          <Route path="/digital-id" element={<DigitalIdApp />} />
          <Route path="/get-wallet-code" element={<DigitalIdCallback />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsAndConditions />} />
        </Routes>
      </div>
    </IdentificationProvider>
  );
}

export default App;
